import React from 'react';
import Base from './../core/Base';
import TodoHome from './../core/TodoHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowDown } from '@fortawesome/free-solid-svg-icons';



const UserDashboard = () => {


  return (
    <>
      <Base>
        <div className='   mt-8  xs:mt-8  sm:mt-10   md:mt-0   text-[#7284a6] text-center font-bold text-2xl drop-shadow-lg pt-3'>Welcome to Dashboard <svg className="animate-bounce w-6 h-6 inline ml-2"><FontAwesomeIcon icon={faCircleArrowDown} /></svg> </div>
        <div className='mt-1  mb-3 text-xs text-[#7284a6] text-center'>Every great achievement begins with a simple 'to do'. Let your dashboard be your guide on the journey to greatness.</div>
        <TodoHome />
      </Base>
    </>
  )
}


export default UserDashboard;